"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const capabilities = [{
  title: "Cybersecurity, Risk & Compliance",
  description: "Practical advisory and implementation support across cybersecurity governance, risk management, ISO standards and UAE regulatory requirements."
}, {
  title: "Secure Technology Architecture",
  description: "Scalable solutions for infrastructure modernization, cloud adoption, API security, AI governance and enterprise technology platforms."
}, {
  title: "Cross-Sector Experience",
  description: "Consulting and technology capabilities supporting public and private organizations across diverse, complex, and regulated industries."
}];
export default function ExperienceHighlights() {
  return <section data-section-id="223871" id="experience-highlights" className="bg-[#142033] text-[#FFFFFF] py-20 md:py-28 lg:py-32" style={{
    "--color-bg-light": "#142033",
    "--color-navy-dark": "#0B1220"
  } as React.CSSProperties}>
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-3xl mb-16">
          <span className="font-mono text-sm font-bold tracking-widest uppercase text-[#FFFFFF] mb-4 block">
            WHY FETC
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#FFFFFF] mb-6 tracking-tight">
            Why Organizations Choose FETC
          </h2>
          <p className="text-lg text-[#D6DCE8] leading-relaxed">
            FETC combines cybersecurity governance, secure technology architecture and practical implementation support to help organizations operate with confidence in complex and regulated environments.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {capabilities.map((item, i) => <CapabilityCard key={i} item={item} index={i} />)}
        </div>
      </div>
    </section>;
}
function CapabilityCard({
  item,
  index
}: {
  item: {
    title: string;
    description: string;
  };
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <div ref={ref} data-index={index} className={cn("bg-[#0B1220] border border-[#243247] rounded-lg p-8 shadow-sm transition-all duration-700 ease-out border-t-4 border-t-[#13B8C8] hover:shadow-lg", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
      <h3 className="text-xl font-bold text-[#FFFFFF] mb-4">
        {item.title}
      </h3>
      <p className="text-[#D6DCE8] leading-relaxed">
        {item.description}
      </p>
    </div>;
}